import {Component, Input} from '@angular/core';
import {ChartState} from '@rsp/models/chart.state';
import {Observable} from 'rxjs';


@Component({
  selector: 'rsp-loading-wrapper',
  templateUrl: './loading-wrapper.component.html',
  styleUrls: ['loading-wrapper.component.scss']

})
export class LoadingWrapperComponent {

  @Input() public state: ChartState = new ChartState();

  constructor() {
  }

  public get showChart(): boolean {
    return !(this.state.isLoading || this.state.hasError || this.state.hasNoData);
  }

  // @Deprecated
  public static load(promise: Promise<any>, chartState: ChartState): Promise<any> {
    return new Promise((resolve) => {
      chartState.setLoading();
      promise.then((result) => {
        chartState.loadingSuccess();
        /*
                if (!DTOHasDataValidator.validate(result)) {
                  chartState.gotNoData();
                }

         */
        resolve(result);
      }).catch(() => {
        chartState.gotError();
      });
    });
  }


}
